import { atom } from "jotai";

export const showBottomNavigationStoreInitialState: boolean = false;

export const ShowBottomNavigationStore = atom(showBottomNavigationStoreInitialState);
